import { I18n } from '@calendly/i18n';
import { IconPlus } from '@calendly/ui/components/glyphs/IconPlus';
import { IconButton } from '@calendly/ui/components/icon-button';
import { AddCircleIcon, AddMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { CopyButton } from '../copy_button';
import { addInterval } from '../utils';
import WdayRule from '../wday_rule';
import { ActionContainer, ActionItem, Checkbox, DayContainer, DayIcon } from './styles';
const labelCss = "lyqvbns";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const v4LabelCss = "v1tmvrcq";
const V4Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(v4LabelCss, props.className)} />;
});
export const Day = ({
  wday,
  days,
  handleCheckboxClick,
  setWdayIntervals,
  cloneWeekdayAvailability,
  className,
  alwaysAbbreviate = false,
  allowCopy = true,
  allowCopyUnavailable = true,
  redesignStyling,
  v4Styling = false
}) => {
  const intervals = days[wday];
  const isPhone = useDeviceType('isPhone');
  const dayNames = I18n.t('date.day_names_hash');
  const abbrDayNames = I18n.t('date.abbr_day_names_hash');
  const DayLabel = v4Styling ? V4Label : Label;
  const [autoFocusLastInterval, startAutoFocusLastInterval, stopAutoFocusLastInterval] = useBooleanState(false);
  const handleAdd = () => {
    setWdayIntervals(wday, addInterval(intervals));
    startAutoFocusLastInterval();
  };
  const handleRemoveSingleInterval = () => {
    handleCheckboxClick(false, wday);
  };
  const useV4ActionButtons = v4Styling || redesignStyling;
  const showV4RowTrash = v4Styling && intervals.length === 1;
  const addIntervalTitle = I18n.t('publisher.availability.schedules.new_interval_with_day', {
    day: dayNames[wday]
  });
  let addIntervalButton = <IconButton title={addIntervalTitle} onClick={handleAdd}>
      <AddMiniIcon />
    </IconButton>;
  if (v4Styling) {
    addIntervalButton = <IconButton title={addIntervalTitle} onClick={handleAdd} size="small" icon={IconPlus} />;
  } else if (useV4ActionButtons) {
    addIntervalButton = <IconButton title={addIntervalTitle} onClick={handleAdd} size="small">
        <AddCircleIcon />
      </IconButton>;
  }
  return <DayContainer key={wday} data-component={wday} onBlur={stopAutoFocusLastInterval} className={className} v4Styling={v4Styling}>
      {redesignStyling && !v4Styling ? <DayIcon>
          {abbrDayNames[wday].slice(0, 1)}
        </DayIcon> : <Checkbox v4Styling={v4Styling} checked={intervals.length > 0} onChange={checked => handleCheckboxClick(checked, wday)} label={<DayLabel>
              {isPhone && !alwaysAbbreviate ? dayNames[wday] : abbrDayNames[wday]}
            </DayLabel>} />}
      <WdayRule day={wday} intervals={intervals} onChange={data => setWdayIntervals(wday, data)} autoFocusLast={autoFocusLastInterval} v4Styling={v4Styling} onRemoveSingleInterval={showV4RowTrash ? handleRemoveSingleInterval : undefined} />
      <ActionContainer v4Styling={v4Styling}>
        {v4Styling ? <ActionItem>{addIntervalButton}</ActionItem> : addIntervalButton}
        {allowCopy && (allowCopyUnavailable || intervals.length > 0) && (v4Styling ? <ActionItem>
              <CopyButton onApply={cloneWeekdayAvailability} day={wday} weekdayRules={days} redesignStyling={useV4ActionButtons} v4Styling={v4Styling} />
            </ActionItem> : <CopyButton onApply={cloneWeekdayAvailability} day={wday} weekdayRules={days} redesignStyling={useV4ActionButtons} v4Styling={v4Styling} />)}
      </ActionContainer>
    </DayContainer>;
};

require("./day.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./day.js");